(function(factory) {
  if (typeof define === "function" && define.amd) {
    // AMD
    define(["jquery", "datatables.net", "datatables-editor"], factory);
  } else if (typeof exports === "object") {
    // Node / CommonJS
    module.exports = function($, dt) {
      if (!$) {
        $ = require("jquery");
      }
      factory($, dt || $.fn.dataTable || require("datatables.net"));
    };
  } else if (jQuery) {
    // Browser standard
    factory(jQuery, jQuery.fn.dataTable);
  }
})(function($, DataTable) {
  "use strict";

  if (!DataTable.ext.editorFields) {
    DataTable.ext.editorFields = {};
  }

  var _fieldTypes = DataTable.Editor
    ? DataTable.Editor.fieldTypes
    : DataTable.ext.editorFields;

  _fieldTypes.number = {
    create: function(conf) {
      var that = this;
      conf._input = $(
        '<input id="' +
          conf.id +
          '" name="' +
          conf.name +
          '" type="number" min="1" class="form-control">'
      )[0];
      return conf._input;
    },

    get: function(conf) {
      return Number($(conf._input).val()); //return the field value POST
    },
    set: function(conf, val) {
      $(conf._input).val(Number(val)); //set the field value
    }
  };
});



// WEBPACK FOOTER //
// ./src/assets/plugins/datatables/editor/number/editor.number.js